module.exports = __webpack_public_path__ + "img/sourcing.c210641.webp";